<!--
 * @Description: select 状态有 【可编辑，不可编辑，详情】
  不处理-9和''，如果有该需求，请使用a-select
-->
<template>
  <template v-if="view && (options || $attrs.viewOptions)">
    <CosSelectView v-if="options" v-bind="$attrs" :options="optionComputed" :fieldNames="fieldNames" :value="modelValue" />
    <slot name="view" :option="viewOption" v-if="$attrs.viewOptions"></slot>
  </template>
  <a-select
    v-else
    v-bind="$attrs"
    v-model:value="modelValue"
    @change="change"
    style="width: 100%"
    :allowClear="allowClear"
    :disabled="disabledComputed"
    :fieldNames="fieldNames"
    :placeholder="placeholder || $t('common.pleaseSelect')"
    :class="{ 'form-item-disabled-view': view }"
    :options="optionComputed"
  >
    <!-- <slot></slot> -->
    <template v-for="(_, name) in $slots" #[name]="slotData">
      <slot :name="name" v-bind="slotData || {}" />
    </template>
    </a-select>
</template>
<script lang="ts" setup>
import { computed, watchEffect, ref, useAttrs, watch } from 'vue'
import { useVModel } from '@vueuse/core'
import CosSelectView from '../CosView/select.vue'
import { useI18n } from 'vue-i18n'
const { t } = useI18n()
const attrs = useAttrs()
const props = defineProps({
  value: {
    type: [String, Number, Array]
  },
  validKey: {
    type: [String, Number, Array]
  },
  autoLanguage: {
    type: Boolean,
    default: true
  },
  placeholder: {
    type: String
  },
  trim: {
    type: Boolean, // 去掉前后空格
    default: true
  },
  view: {
    type: Boolean
  },
  disabled: {
    type: Boolean,
    default: false
  },
  allowClear: {
    type: Boolean,
    default: true
  },
  clearVal: {
    type: [String, Number, Array]
  },
  filterNoVal: {
    type: Boolean, // 是否清除0 null-》 '' 只处理字符串
    default: false
  },
  options: {
    type: Array
  },
  fieldNames: {
    type: Object
  }
})
const disabledComputed = computed(() => {
  return props.view ? true : props.disabled
})
const optionComputed = computed(() => {
  if (!props.autoLanguage) {
    return props.options
  }
  if (props.options) {
    const label = props.fieldNames?.label || 'label'
    props.options?.forEach((item: any) => {
      if (item.lang) {
        item[label] = t(item.lang)
      }
    })
  }
  return props.options
})
const emit = defineEmits(['update:value', 'update:validKey', 'change'])
const vaildValue = useVModel(props, 'validKey', emit)
const modelValue = ref()
const viewOption = computed(() => {
  const viewOptions: any = attrs.viewOptions
  const { mode } = attrs
  let result: any
  const fieldNames: any = attrs.viewFieldNames
  const valKey = fieldNames && fieldNames.value ? fieldNames.value : 'value'
  const obj: any = {}
  if (mode === 'multiple') {
    result = []
    if (props.value && Array.isArray(props.value)) {
      props.value.forEach((item) => {
        const findv = viewOptions?.find((v: any) => v[valKey] === item)
        obj[valKey] = item
        result.push(findv || obj)
      })
    }
    return result || []
  } else {
    const findv = viewOptions?.find((item: any) => item[valKey] === props.value)
    obj[valKey] = props.value
    result = findv || obj
    return result
  }
})

const change = (v: any) => {
  let result = v
  if (attrs.mode !== 'multiple') {
    if (v === undefined) {
      const options: any = attrs.options
      if (options && options.length) {
        // init 类型就是-9 string ''  只处理带有options
        const vkey = (props.fieldNames && (props.fieldNames as any).value) || 'value'
        if (typeof options[0][vkey] === 'string') {
          result = ''
        } else {
          result = -9
        }
      } else if (typeof props.value === 'number') {
        result = -9
      }
      if (props.clearVal !== undefined) {
        result = props.clearVal
      }
    }
  }
  if (result === -9) {
    vaildValue.value = undefined
  } else {
    vaildValue.value = result
  }
  emit('update:value', result)
  emit('change', result)
}
watch(
  () => props.value,
  (v) => {
    if (v !== -9 && v !== '') {
      modelValue.value = v
      vaildValue.value = v
      if (attrs.mode === 'multiple') {
        // 多选去掉null
        if (v === null) {
          modelValue.value = []
        }
      }
    } else {
      modelValue.value = undefined
      vaildValue.value = undefined
    }
  },
  { immediate: true }
)
watchEffect(() => {
  if (props.filterNoVal && (modelValue.value === 0 || modelValue.value === '' || modelValue.value === null)) {
    modelValue.value = undefined
  }
})
</script>
